
class exports.Parent_Dialog_Handler extends FullPageHandler

    init: () ->
        @classes = 'portal-convert-dialog'
        @createDialog()
        @openDialog()
        @displayLoadingMessage()

    saveStub: () -> #stub
        return

    rowCallback: (row, data) -> #stub
        return

    refreshReport: () ->
        @filters = @parent.getAppliedFilters()

        s = @table.dataTable().fnSettings()
        s._iDisplayStart = 0
        s._iDisplayEnd = s._iDisplayStart + s._iDisplayLength

        @table.dataTable().fnDraw()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ths = this

        # If dialog changes size, resize the datatable to eat up the remaining space
        $(window).unbind('modal_resized').bind 'modal_resized', debounce (e) =>
            size = @dialog.find('.modal-body').height() - 177

            @table.fnSettings().sY = size + "px"
            $('.dataTables_scrollBody').height(size)
            @table.dataTable().fnAdjustColumnSizing(false)

        # grab the currently applied filters
        @filters = @parent.getAppliedFilters()

        @msg = @dialog.find('.message_writer').message_writer()
        if @msg.length isnt 0
            @msg.message_writer('success', 'Report Finished')
            @msg.message_writer('hide')


        @dialog.find('.modal-body').resizr()

        setTimeout () =>
            @buildTable()
        , 250

        @initializeListeners()


    showHideButton: () ->
        if @dialog.find('.chk-copy:checked').length
            @dialog.find('#btn-autofill-actual').show()
        else
            @dialog.find('#btn-autofill-actual').hide()


    buildTable: () ->
        if not @reportAjax? then @reportAjax = ''

        size = @dialog.find('.modal-body').height() - 177
        @table = @dialog
            .find('.table').dataTable
                sScrollY: size + "px"
                #sScrollX:       "100%"
                bDestroy: true
                bFilter: false
                bInfo: false
                bSort: false
                bPaginate: true
                bServerSide: true
                bScrollCollapse: true
                iDisplayLength: 50
                sAjaxSource: @reportAjax
                sPaginationType: "bootstrap"
                fnServerParams: (aoData) =>
                    aoData.push({ name: "query", value: ko.toJSON @filters })
                fnInitComplete: () ->
                    @fnAdjustColumnSizing(true)
                fnRowCallback: (row, data) =>
                    @rowCallback(row, data)

        @table.fnDraw()


    initializeListeners: () ->
        ths = this
        # Header checkbox (convert)
        @dialog.find('#chk-autofill').bind 'click', () ->
            chkd = $(this).is(':checked')
            ths.dialog.find('.chk-copy').prop('checked', chkd)
            ths.showHideButton()

        # Header estimated percent or days autofill (delivery, convert)
        @dialog.find('#txt-autofill-percent, #txt-autofill-days').bind 'change', () ->
            val = $(this).val()
            $(this).val('')
            ths.dialog.find('.txt-actual-percent, .txt-days').val(val).change()

        # Gaurd Header percent (convert)
        @dialog.on 'keyup.convert', '#txt-autofill-percent', () ->
            $(this).val( $(this).val().replace(/[^\d\.]+/g, '') )

        # Gaurd days txt boxes (delivery)
        @dialog.on 'keyup.convert', '#txt-autofill-days', () ->
            $(this).val( $(this).val().replace(/[^-^\d]+/g, '') )

        # Gaurd acres txt boxes (convert)
        @dialog.on 'keyup.convert', '.txt-actual-acres', () ->
            $(this).val( $(this).val().replace(/[^\d\.]+/g, '') )

        # Gaurd pop txt boxes (convert)
        @dialog.on 'keyup.convert', '.txt-actual-pop', () ->
            $(this).val( $(this).val().replace(/[^\d]+/g, '') )

        # Gaurd days txt boxes (delivery)
        @dialog.on 'keyup.convert', '.txt-days', () ->
            $(this).val( $(this).val().replace(/[^-^\d]+/g, '') )

        # Gaurd percent txt boxes (convert)
        @dialog.on 'keyup.convert', '.txt-actual-percent', () ->
            $(this).val( $(this).val().replace(/[^\d\.]+/g, '') )

        # Gaurd date txt boxes (convert)
        @dialog.on 'change.convert', '.txt-actual-date', () ->
            $(this).val( $(this).val().replace(/[^\d\-\/]+/g, '') )

        # Autofill all checked rows (convert)
        @dialog.find('#btn-autofill-actual').bind 'click', () ->
            ths.dialog.find('#chk-autofill').prop('checked', false)
            for elem in ths.dialog.find('.chk-copy:checked')
                elem = $(elem)
                elem.prop('checked', false)
                elem.closest('tr').find('.copy-btn').click()
            $(this).hide()

        # Show/hide autofill actual button (convert)
        @dialog.on 'click.convert', '.chk-copy', () =>
            @showHideButton()

        # Copy individual line (convert)
        @dialog.on 'click.convert', '.copy-btn', () ->
            row = $(this).closest 'tr'
            acres   = row.find('.txt-actual-acres')
            pop     = row.find('.txt-actual-pop')
            percent = row.find('.txt-actual-percent')

            acres.val(row.find('.txt-plan-acres').val()) if not acres.val()
            pop.val(row.find('.txt-plan-pop').val())     if not pop.val()
            percent.val(100)                             if not percent.val()

            percent.change()

            chk = row.find('.chk-copy')
            if chk.is(':checked')
                chk.click()
                ths.showHideButton()

        # Update Hrvst Date
        @dialog.on 'change.convert', '.txt-days', () ->
            adj = $(this).val()
            plant_txt = $(this).closest('.actual-row').find('.txt-actual-date').val()
            days = $(this).closest('.actual-row').find('.days').val()
            plant = moment(plant_txt, "MM-DD-YYYY")

            adj = if adj? and adj isnt '' and adj % 1 is 0 then adj else 0
            days = if days? then days else 0
            days_adj = parseInt(days) + parseInt(adj)

            plant.add(days_adj, "days")
            hrvstInput = $(this).closest('.actual-row').find('.hrvst_date')
            hrvstInput.val(plant.format('MM/DD/YYYY'))

        # Update Est. Yield calculation
        @dialog.on 'change.convert', '.txt-actual-percent', () ->
            row = $(this).closest('tr')
            yld = row.find('.txt-plan-yield').val() * $(this).val() / 100.0
            row.find('.txt-actual-yield').val(yld)

        # Save button
        @dialog.find('.save-btn').bind 'click', () =>
            @saveStub()

        # Revalidate the inputs on change
        @dialog.on 'change', '.mfvalidate-invalid', () ->
            $(this).removeClass('mfvalidate-invalid')
            if ths.dialog.find('.mfvalidate-invalid').length is 0
                ths.dialog.find('.errorDiv').hide()

        # Cancel button
        @dialog.find('.cancel-btn').bind 'click', () =>
            for elem in @dialog.find('[data-orig]')
                elem = $(elem)
                elem.val(elem.data('orig'))

        # Export button
        @dialog.find('.export-btn').bind 'click', () =>
            if not @exportUrl? then @exportUrl = ''
            url = @exportUrl + "?filters=" + ko.toJSON @parent.getAppliedFilters()
            window.open(url, '_blank')
